(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magic-seo-content"] && !Shopify.designMode) return;
  try {
    
  function initMagicSeo(root) {
    if (!root || root.dataset.magicSeoReady === 'true') return;

    var body = root.querySelector('[data-magic-seo-body]');
    var toggle = root.querySelector('[data-magic-seo-toggle]');
    var label = root.querySelector('[data-magic-seo-label]');
    if (!body || !toggle) return;

    root.dataset.magicSeoReady = 'true';

    var moreLabel = label ? label.textContent : 'Read More';
    var lessLabel = root.getAttribute('data-read-less') || 'Read Less';
    var collapsedHeight = body.style.maxHeight || '22rem';

    function syncOverflow() {
      if (root.classList.contains('is-expanded')) return;
      var overflows = body.scrollHeight > body.clientHeight + 2;
      root.classList.toggle('is-short', !overflows);
    }

    toggle.addEventListener('click', function () {
      var expanded = root.classList.toggle('is-expanded');
      body.style.maxHeight = expanded ? 'none' : collapsedHeight;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) label.textContent = expanded ? lessLabel : moreLabel;
      if (!expanded) syncOverflow();
    });

    syncOverflow();
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(syncOverflow).observe(body);
    }
  }

  function initAllMagicSeo(scope) {
    (scope || document).querySelectorAll('[data-magic-seo]').forEach(initMagicSeo);
  }

  initAllMagicSeo(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllMagicSeo(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
